<template>
  <div>
    <el-dialog
        :title="'Tạo mã QR code'"
        :visible.sync="showCreateQRCodeDialog"
        width="800px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row type="flex" :gutter="10">
          <el-col :span="8">
            <el-date-picker
                style="width: 100%"
                size="medium"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
            ></el-date-picker>
          </el-col>
          <el-col :span="8">
            <el-select
                size="medium"
                v-model="dataInput.idSchool"
                placeholder="Chọn trường"
                filterable
                clearable
                style="width: 100%"
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.id+' - '+item.schoolName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <div style="margin-bottom: 6px">Cố định</div>
            <el-radio-group
                v-model="dataInput.fixed"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="2">
            <el-button
                size="small"
                :loading="buttonLoading"
                @click="createQrCodeForOneAdminManual()"
                type="primary"
            >Tạo QR code
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showCreateQRCodeDialog: {
      type: Boolean,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataInput: {
        date: "",
        idSchool: "",
        fixed: false,
      },
      buttonLoading: false,
      listSchool: [],
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.date = "";
      this.dataInput.fixed = false;
      this.dataInput.idSchool = "";
      this.buttonLoading = false
      this.$emit('close', false);
    },
    createQrCodeForOneAdminManual() {
      let dataInputNew = {
        date: this.dataInput.date,
      };

      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày tạo mã QR Code",
          type: "error",
        });
        throw null;
      }
      let alertText = this.dataInput.idSchool === "" ? "cho TOÀN BỘ các trường" : "";
      this.$confirm(
          "Bạn có chắc chắn muốn tạo mã QR Code " + alertText + " không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(async () => {
        this.buttonLoading = true;
        await OtherService.createQrCodeForOneAdmin(
            dataInputNew,
            this.dataInput.idSchool,
            this.dataInput.fixed,
        )
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading = false;
              }, 1000);
            });
      });
    },


  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
